import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MuiCard from '@mui/material/Card';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import Content from '../content/Content';
import { styled } from '@mui/material/styles';
import { Alert, Grid, Snackbar } from '@mui/material';

const API = require("../../data/network/API");

function Copyright(props) {
  return (
    <Stack spacing={4} sx={{mt:2}}>
      <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {new Date().getFullYear()} {'© SwitchPoint SA. de CV. All rights reserved'}
      </Typography>
      <Box
          alignSelf= 'center'
          component="img"
          sx={{
            height: 32,
            width: 80,
          }}
          alt="officia logo."
          src="/static/sw.png"
        />
    </Stack>
  );
}

const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  backgroundColor: 'transparent',
  gap: theme.spacing(2),
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  [theme.breakpoints.up('sm')]: {
    width: '450px',
  },
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

function ValidateEmailCard() {
  const navigate = useNavigate();

  const [snackbarState, setSnackbarState] = React.useState({open:false,message:"",status:"info"});
  const [loader, setLoader] = React.useState(false);

  
  const handleSubmit = async(event) => {
    event.preventDefault();

    const data = new FormData(event.currentTarget);
    const email = data.get('email')

    if(email.length==0){
      setSnackbarState({ open: true, message: "Por favor llena todos los campos.", status: "warning"})
      return
    }

    const requestBody = {
      correo: email,
      canal: "app",
      app: "guna-lealtad",
    }

    setLoader(true);
    const response = await API.postVerificationCode(requestBody)
    setLoader(false);

    if(response.status == 201){

      console.log(response.data)

      navigate('/verification-Code',{ state: { correo: email, confirmation_code: response.data.firestore_id }});
    }else{
      setSnackbarState({open:true, message: response.message, status:"error"})
    }
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({open:false,message:snackbarState.message,status:snackbarState.status})
  };

  return (
    <Card >
      <Box
        alignSelf= 'center'
        component="img"
        sx={{
          height: 56,
          width: 56,
        }}
        alt="officia logo."
        src="/static/logo_guna.png"
      />
       <Box
        alignSelf= 'center'
        component="img"
        sx={{
          height: 256,
          width: 256,
        }}
        alt="officia logo."
        src="/static/sign_in_ background.png"
      />
      <Typography
        variant="h5" 
      >
        Nesitamos validar tu correo
      </Typography>
      <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
        <TextField
          margin="normal"
          required
          fullWidth
          id="email"
          label="Ingresa tu correo electrónico"
          name="email"
          autoComplete="email"
          variant="filled"
          autoFocus
          color='secondary'
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color='secondary'
          sx={{ mt: 3, mb: 2 }}
        >
          Continuar
        </Button>
        <Grid container>
          <Grid item xs>
            <Stack spacing={2}>
             
              <Typography variant="body2" color="text.secondary" align="center">
              Al registrate, aceptas nuestras condiciones de uso y venta.
              </Typography>
              <Typography align='center'>
                <Link href="/privacy" variant="body2" color={"secondary"} >
                  Aviso de privicidad
                </Link>
              </Typography>
            </Stack>
          </Grid>
          <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={snackbarState.open} onClose={handleClose}>
            <Alert
              onClose={handleClose}
              severity={snackbarState.status}
              variant="filled"
            >
              {snackbarState.message}
            </Alert>
          </Snackbar>
        </Grid>
        <Copyright/>
      </Box> 
    </Card>
  );
}

export default function ValidateEmail() {
  return (
    <>
      <CssBaseline enableColorScheme />
      <Stack
        direction="column"
        component="main"
        sx={[
          {
            justifyContent: 'center',
            height: 'calc((1 - var(--template-frame-height, 0)) * 100%)',
            //marginTop: 'max(40px - var(--template-frame-height, 0px), 0px)',
            minHeight: '100%',
          },
        ]}
      >
        <Stack
          direction={{ xs: 'column-reverse', md: 'row' }}
          sx={{
            justifyContent: 'center',
            gap: { xs: 6, sm: 12 },
            mx: 'auto',
          }}
        >
          <Stack
            direction={{ xs: 'column-reverse', md: 'row' }}
            sx={{
              justifyContent: 'center',
              gap: { xs: 6, sm: 12 },
              p: { xs: 0, sm: 4 },
              m: 'auto',
            }}
          >
            <Content />
            <ValidateEmailCard />
          </Stack>
        </Stack>
      </Stack>
    </>
  );
}